import { render } from "./USDTDeposit.vue?vue&type=template&id=0a5d9abc&scoped=true"
import script from "./USDTDeposit.vue?vue&type=script&lang=js"
export * from "./USDTDeposit.vue?vue&type=script&lang=js"

import "./USDTDeposit.vue?vue&type=style&index=0&id=0a5d9abc&lang=less&scoped=true"
import "./USDTDeposit.vue?vue&type=style&index=1&id=0a5d9abc&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5d9abc"]])

export default __exports__